import { FormattedMessage } from 'react-intl';
import { FilterItem } from '@molecules/filters/filtersMenu';
import { FilterGeneral } from '@libs/store/filters';
import { Specialty } from '@libs/models/talents';

type SpecialtyFilterMenuProps = {
  localizationSubset: string;
  options: Specialty[];
  getFilter: (key: string) => FilterGeneral<string[]> | null;
  key: string;
};
export function useSpecialtyFilterMenu({
  localizationSubset,
  options,
  getFilter,
  key,
}: SpecialtyFilterMenuProps): FilterItem {
  const filter = getFilter(key);

  return {
    label: <FormattedMessage id={`${localizationSubset}.filters.${key}.label`} />,
    key: key,
    multiple: true,
    children: options.map((item) => ({
      label: item.name,
      key: item.id,
      valueView: item.name,
      selected: filter?.value.includes(item.id) || false,
    })),
  };
}
